import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

function fmt(value, currency = "EUR") {
  if (value == null) return "—";
  try {
    return new Intl.NumberFormat("es-ES", { style: "currency", currency, maximumFractionDigits: 2, useGrouping: "always" }).format(value);
  } catch { return `${value} ${currency}`; }
}

export function DiscrepanciesModal({ data, baseCurrency, onClose, onOpenInvoice, lang }) {
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="discrepancies-modal">
        <DialogHeader>
          <DialogTitle>
            {lang === "es" ? `Discrepancias de ${data.month}` : `Mismatches for ${data.month}`}
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="px-3 py-2 rounded border border-[var(--border-color)] bg-[var(--surface)]">
            <div className="text-[10px] uppercase tracking-wider text-[var(--text-muted)]">
              {lang === "es" ? "Sobrepagado" : "Overpaid"}
            </div>
            <div className="font-mono-num font-semibold text-amber-600">
              {fmt(data.overpaid_total, baseCurrency)}
            </div>
          </div>
          <div className="px-3 py-2 rounded border border-[var(--border-color)] bg-[var(--surface)]">
            <div className="text-[10px] uppercase tracking-wider text-[var(--text-muted)]">
              {lang === "es" ? "Líneas" : "Lines"}
            </div>
            <div className="font-mono-num font-semibold">{data.issues_count}</div>
          </div>
          <div className="px-3 py-2 rounded border border-[var(--border-color)] bg-[var(--surface)]">
            <div className="text-[10px] uppercase tracking-wider text-[var(--text-muted)]">
              {lang === "es" ? "Facturas" : "Invoices"}
            </div>
            <div className="font-mono-num font-semibold">{data.impacted_invoices}</div>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-wider text-[var(--text-muted)]">
              <tr className="border-b border-[var(--border-color)]">
                <th className="text-left py-2 px-2">{lang === "es" ? "Proveedor" : "Vendor"}</th>
                <th className="text-left py-2 px-2">{lang === "es" ? "Producto" : "Product"}</th>
                <th className="text-right py-2 px-2">€/ud fact.</th>
                <th className="text-right py-2 px-2">€/ud alb.</th>
                <th className="text-right py-2 px-2">Δ %</th>
                <th className="text-right py-2 px-2">{lang === "es" ? "Impacto" : "Impact"}</th>
                <th className="w-20" />
              </tr>
            </thead>
            <tbody>
              {data.issues.map((iss, idx) => (
                <tr key={`${iss.invoice_id}-${iss.line_index}`}
                    className="border-b border-[var(--border-color)] last:border-0"
                    data-testid={`discrepancy-row-${idx}`}>
                  <td className="py-1.5 px-2">
                    <div className="text-sm">{iss.vendor || "—"}</div>
                    <div className="text-[10px] text-[var(--text-muted)]">{iss.invoice_number || ""} · {iss.date || ""}</div>
                  </td>
                  <td className="py-1.5 px-2 capitalize">{iss.product}</td>
                  <td className="py-1.5 px-2 text-right font-mono-num">{iss.invoice_unit_price.toFixed(4)}</td>
                  <td className="py-1.5 px-2 text-right font-mono-num">{iss.albaran_unit_price.toFixed(4)}</td>
                  <td className="py-1.5 px-2 text-right font-mono-num text-amber-600">+{iss.unit_diff_pct}%</td>
                  <td className="py-1.5 px-2 text-right font-mono-num font-medium text-[var(--status-negative)]">
                    {fmt(iss.impact, baseCurrency)}
                  </td>
                  <td className="py-1.5 px-2 text-right">
                    <button
                      onClick={() => onOpenInvoice(iss.invoice_id)}
                      className="text-xs text-[var(--primary)] hover:underline"
                      data-testid={`discrepancy-open-${idx}`}
                    >
                      {lang === "es" ? "Ver" : "View"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{lang === "es" ? "Cerrar" : "Close"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

